import { useEffect, useRef, useState } from "react";
import { pick } from "../utils/random";
import type { EffectProps } from "./types";

const CHARS = ["♥", "♡", "💖", "💕"];

type Drop = { id: number; x: number; y: number; char: string };

export function HeartCursor(_props: EffectProps = {}) {
  const [drops, setDrops] = useState<Drop[]>([]);
  const idRef = useRef(0);
  const lastRef = useRef(0);

  useEffect(() => {
    const onMove = (e: PointerEvent) => {
      const now = performance.now();
      if (now - lastRef.current < 60) return;
      lastRef.current = now;
      const id = idRef.current++;
      const drop: Drop = { id, x: e.clientX, y: e.clientY, char: pick(CHARS) };
      setDrops(d => [...d.slice(-30), drop]);
      window.setTimeout(() => {
        setDrops(d => d.filter(x => x.id !== id));
      }, 1200);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <div className="fx-layer" aria-hidden>
      {drops.map(d => (
        <span
          key={d.id}
          className="fx-cursor-heart"
          style={{ left: d.x, top: d.y }}
        >
          {d.char}
        </span>
      ))}
    </div>
  );
}
